import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { usersApi } from '../../api/users';
import UserProfilePage from '../mypage/profile/UserProfilePage';

const UserPage = () => {
  const { nickname, userId } = useParams();
  // Preserve tabs of a real member literally named "by-id".
  const legacyTab = ['reviews', 'lists', 'comments', 'saved'].includes(userId) ? userId : null;
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!userId || legacyTab) return undefined;
    const controller = new AbortController();
    let active = true;
    setResult(null);
    const load = async () => {
      try {
        if (!/^[1-9]\d*$/.test(userId) || !Number.isSafeInteger(Number(userId)))
          throw new Error('Invalid user ID');
        const response = await usersApi.getUserById(userId, { signal: controller.signal });
        const user = response.data;
        if (user?.id !== Number(userId) || !user.nickname) throw new Error('Invalid profile');
        if (active) setResult({ id: userId, nickname: user.nickname });
      } catch {
        if (active) setResult({ id: userId, error: true });
      }
    };
    void load();
    return () => {
      active = false;
      controller.abort();
    };
  }, [userId, attempt, legacyTab]);
  if (legacyTab) return <UserProfilePage nickname="by-id" legacyTab={legacyTab} />;
  if (!userId) return <UserProfilePage nickname={nickname} />;
  if (result?.id !== userId)
    return (
      <Box sx={{ p: 4 }}>
        <CircularProgress aria-label="프로필 불러오는 중" />
      </Box>
    );
  if (result.error)
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error">프로필이 없거나 불러올 수 없습니다.</Alert>
        <Button onClick={() => setAttempt((value) => value + 1)}>다시 시도</Button>
      </Box>
    );
  return <UserProfilePage key={result.nickname} nickname={result.nickname} />;
};

export default UserPage;
